import { Button, Radio } from "pepsico-ds";
import React from "react";

const ActionCellRender = (props) => {
    const { buttons = [], openModal, openViewModal, data } = props;
    const safeButtons = Array.isArray(buttons) ? buttons.filter(Boolean) : [];

    const handleAction = (type) => {
        if (type === 'View') {
            props.openViewModal(type, props.data, 'single');
        } else if( type === 'Approve' || type === 'Reject') {
            props.openModal(type, props.data, 'single');
        }
        else if(type === 'select' && props?.data?.fromType === 'user_profile_search') {
            props.onSelectUser(props.data);
        }
        else if(type === 'select') {
            props.onSelectUser(props.data);
        }
    };

    return (
        <div className="d-flex justify-content-between align-items-center gap-2 h-100">
            {props?.data?.fromType !== 'user_profile_search' && safeButtons.map((btn, index) => (
                <Button
                    key={index}
                    size="small"
                    text={btn?.text || ""}
                    variant={btn?.variant || "primary"}
                    disabled={data?.isDisabled}
                    onClick={() => handleAction(btn?.action)}
                />
            ))}
            {props?.data?.fromType === 'user_profile_search' &&(
                <div>
                    <Radio
                        className=""
                        helperText=""
                        items={[{ label: '', value: 'select' }
                        ]}
                        showText={false}
                        selected={props?.data?.isSelected }
                        label=""
                        orientation="vertical"
                        reference="radio button"
                        size="small"
                        style={{}}
                        onUpdate={(e) => handleAction('select')}
                    />
                </div>
            )}
            {/* <Button
                size="small"
                text="Approve"
                variant="primary"
                disabled={props?.data?.isDisabled}
                onClick={() => handleAction("Approve")}
            />
            <Button
                size="small"
                text="Reject"
                variant="danger"
                disabled={props?.data?.isDisabled}
                onClick={() => handleAction("Reject")}
            />
            <Button
                size="small"
                text="View More"
                variant="auxiliary"
                onClick={() => handleAction("View")}
            /> */}
        </div>
    );
}
export default ActionCellRender;